// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { SystemDetailsModel } from '../../../api/remote-api/.portal.generated/models';
export class UrlBuilder {
  public static replaceUrlPlaceholder(
    url: string,
    systemDetails: SystemDetailsModel,
    ticketNumber: string,
    filterName: string,
    currentDateFormat?: string,
    modalityName?: string
  ): string {
    let replaceUrl: string;

    replaceUrl = this.replaceInsensitive(
      url,
      '{systemSerialNumber}',
      '' + systemDetails.systemSerialNumber
    );
    replaceUrl = this.replaceInsensitive(
      replaceUrl,
      '{systemMaterialNumber}',
      '' + systemDetails.systemMaterialNumber
    );
    replaceUrl = this.replaceInsensitive(
      replaceUrl,
      '{modalityId}',
      '' + systemDetails.modalityId
    );
    replaceUrl = this.replaceInsensitive(
      replaceUrl,
      '{modality}',
      '' + modalityName
    );

    replaceUrl = this.replaceInsensitive(
      replaceUrl,
      '{customerName}',
      systemDetails.customerName
    );
    replaceUrl = this.replaceInsensitive(
      replaceUrl,
      '{customerLocation}',
      systemDetails.customerLocation
    );

    replaceUrl = this.replaceInsensitive(
      replaceUrl,
      '{systemName}',
      systemDetails.systemName
    );
    replaceUrl = this.replaceInsensitive(
      replaceUrl,
      '{systemSoftwareVersion}',
      systemDetails.systemSoftwareVersion
    );

    replaceUrl = this.replaceInsensitive(
      replaceUrl,
      '{dateFormat}',
      currentDateFormat || ''
    );

    replaceUrl = this.replaceInsensitive(
      replaceUrl,
      '{filterName}',
      filterName
    );
    replaceUrl = this.replaceInsensitive(
      replaceUrl,
      '{modalityId}',
      systemDetails.modalityId.toString()
    );
    replaceUrl = this.replaceInsensitive(
      replaceUrl,
      '{ticketNumber}',
      ticketNumber
    );
    return replaceUrl;
  }

  private static replaceInsensitive(
    source: string,
    searchMask: string,
    replaceMask: string
  ): string {
    const regEx = new RegExp(searchMask, 'ig');
    return source?.replace(regEx, replaceMask);
  }
}
